import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface OsPermissionStatus {
    auth: string;
    status: string;
}

@Injectable({
    providedIn: 'root',
})
export class OsPermissionService {
    public constructor(private http: HttpClient) {}

    public requestPermission(app: string) {
        const formData = new FormData();
        formData.append('action', 'USER-AUTH_REQUEST');
        formData.append('page', 'APPLICATION_REQUEST');
        formData.append('addon', 'USER');
        formData.append('AUTH', app);

        return this.http.post('/online-support/c/main.do', formData, { responseType: 'text' });
    }

    public getPermissionStatus(permission: string) {
        return this.http.get<OsPermissionStatus>(`/online-support/api/os-user/v1/permissions/${permission}`);
    }
}
